/**
 * Creates a clean, styled drag preview element for email drag and drop operations
 * Enhanced with Motion-inspired smooth animations and modern styling
 * @param text The text to display in the drag preview
 * @param event The drag event to attach the preview to
 */
export function createEmailDragPreview(text: string, event: DragEvent | React.DragEvent): void {
  const dragPreview = document.createElement('div');

  // Position off-screen
  dragPreview.style.position = 'absolute';
  dragPreview.style.top = '-1000px';
  dragPreview.style.left = '-1000px';

  // Enhanced styling with Motion-inspired design
  dragPreview.style.padding = '10px 16px';
  dragPreview.style.backgroundColor = 'rgba(255, 255, 255, 0.98)';
  dragPreview.style.backdropFilter = 'blur(16px) saturate(180%)';
  dragPreview.style.border = '1.5px solid rgba(59, 130, 246, 0.4)';
  dragPreview.style.borderRadius = '12px';
  // Enhanced shadow with elevation and glow effect
  dragPreview.style.boxShadow = '0 12px 40px -8px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(59, 130, 246, 0.6), 0 0 20px rgba(59, 130, 246, 0.15)';
  dragPreview.style.maxWidth = '300px';
  dragPreview.style.fontSize = '13px';
  dragPreview.style.fontWeight = '600';
  dragPreview.style.color = '#1f2937';
  dragPreview.style.whiteSpace = 'nowrap';
  dragPreview.style.overflow = 'hidden';
  dragPreview.style.textOverflow = 'ellipsis';
  dragPreview.style.zIndex = '10000';
  dragPreview.style.letterSpacing = '0.01em';
  // Remove transform to avoid positioning issues
  dragPreview.style.pointerEvents = 'none';

  // Content with better icon
  dragPreview.textContent = `📧 ${text}`;

  // Append to body temporarily
  document.body.appendChild(dragPreview);

  // Get dimensions for centering
  const rect = dragPreview.getBoundingClientRect();

  // Set as drag image - center it on the cursor by using half width/height as offset
  event.dataTransfer?.setDragImage(dragPreview, rect.width / 4, rect.height / 2);

  // Clean up after a short delay
  setTimeout(() => {
    if (document.body.contains(dragPreview)) {
      document.body.removeChild(dragPreview);
    }
  }, 0);
}

